import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChargingStation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.5 15.5V13H10.25C10.0667 13 9.92933 12.925 9.838 12.775C9.746 12.625 9.74167 12.475 9.825 12.325L11.825 8.35C11.9083 8.18333 12.0417 8.12067 12.225 8.162C12.4083 8.204 12.5 8.31667 12.5 8.5V11H13.75C13.9333 11 14.071 11.075 14.163 11.225C14.2543 11.375 14.2583 11.525 14.175 11.675L12.175 15.65C12.0917 15.8167 11.9583 15.8793 11.775 15.838C11.5917 15.796 11.5 15.6833 11.5 15.5ZM7 23C6.45 23 5.97933 22.8043 5.588 22.413C5.196 22.021 5 21.55 5 21V3C5 2.45 5.196 1.979 5.588 1.587C5.97933 1.19567 6.45 1 7 1H17C17.55 1 18.021 1.19567 18.413 1.587C18.8043 1.979 19 2.45 19 3V21C19 21.55 18.8043 22.021 18.413 22.413C18.021 22.8043 17.55 23 17 23H7ZM7 18H17V6H7V18ZM7 20V21H17V20H7ZM7 4H17V3H7V4Z",
		fill: "currentColor"
	})
});
export default SvgChargingStation;
